import { IServant } from 'core-ts-types';
import { Account, IAccount, IAccountAPI } from '../builders/account_builder';

export class AccountServant implements IServant {
  constructor(private ngAccountBuilder: typeof Account) {}

  createInvalid(): Account {
    return this.createAnonymous({
      token: ''
    });
  }

  isValid(account: IAccount): boolean {
    return _.isString(account.token) && _.size(account.token) > 0;
  }

  createAnonymous(source: IAccountAPI): Account {
    return new this.ngAccountBuilder(
      _.merge(source, {
        isAnonymous: true
      })
    );
  }

  createIdentified(source: IAccountAPI): Account {
    return new this.ngAccountBuilder(
      _.merge(source, {
        isAnonymous: false
      })
    );
  }

  updateExpireTime(account: Account): Account {
    this.ngAccountBuilder.updateExpireTime(account);
    return account;
  }

  constructNetworkAuthenticationHeader(account: IAccount, httpConfiguration: ng.IRequestConfig): ng.IRequestConfig {
    if (!this.isValid(account)) {
      return httpConfiguration;
    }

    const authenticationToken: string = account.isAnonymous ? `Lazy-Token ${account.token}` : `Token ${account.token}`;

    httpConfiguration.headers = _.merge(httpConfiguration.headers, {
      'Content-Type': 'application/json;odata=verbose; charset=UTF-8',
      Authorization: authenticationToken
    });

    return httpConfiguration;
  }
}

angular.module('capability-ng-user-app').service('ngAccountServant', AccountServant);



// WEBPACK FOOTER //
// ./app/lib/user_app/servants/account_servant.ts